import { Injectable } from '@angular/core';
import { BaseHttpService } from './base-http.service';
import { URLS } from '../shared/url';
import { Observable } from 'rxjs';
import { DepartmentGridViewModel, DepartmentViewModel } from '../models/generated-view-models';
import { ResponseTypeEnum } from '../models/enums';

@Injectable({
    providedIn: 'root'
})
export class DepartmentService {

    constructor(private http: BaseHttpService) { }

    public getDepartmentList = (): Observable<DepartmentGridViewModel[]> => {
        return this.http.Get(URLS.getDepartmentList);
    }

    public getDepartment = (departmentId: number): Observable<DepartmentViewModel> => {
        return this.http.Get(`${URLS.getDepartment}/${departmentId}`);
    }

    public saveDepartment = (department: DepartmentViewModel): Observable<boolean> => {
        return this.http.Post(URLS.saveDepartment, department, ResponseTypeEnum.Success);
    }

    public deleteDepartment = (departmentId: number): Observable<boolean> => {
        return this.http.Delete(`${URLS.deleteDepartment}/${departmentId}`, ResponseTypeEnum.Success);
    }
}
